// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3LmRaBnH2gWyObedt1ka2N {\n  color: #000;\n  display: inline-block;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 0.857rem;\n}\n._2pJy8AfhJ-BPvRfYpGw1by:before {\n  content: '[ ';\n}\n._2pJy8AfhJ-BPvRfYpGw1by:after {\n  content: ' ]';\n}\n._1BA1SbjZvdRmWH04EgYW_E:before {\n  content: '{ ';\n}\n._1BA1SbjZvdRmWH04EgYW_E:after {\n  content: ' }';\n}\n._-6VWL5jq42gdU8IAaeyaZ {\n  color: #f5a623;\n}\n._2QUr-5bBL92DL7D3o5yJVQ {\n  color: #57a700;\n}\n._2ioumvoqJC3jtc_Oi-GL0J {\n  color: #57a700;\n}\n._3Ao6vWP9iMqek8ddof2GbM {\n  padding-right: 0.5rem;\n}\n._3Ao6vWP9iMqek8ddof2GbM:after {\n  content: ':';\n}\n.Tw7PKhn38U-pBfw9wKyju:not(:last-of-type) {\n  padding-right: 0.5rem;\n}\n.Tw7PKhn38U-pBfw9wKyju:not(:last-of-type):after {\n  color: #000;\n  content: ',';\n}\n._1W_loGH-7LSLaHLQYM7Sj1 {\n  color: #ff5c5c;\n}\n", ""]);
// Exports
exports.locals = {
	"json-payload": "_3LmRaBnH2gWyObedt1ka2N",
	"jsonPayload": "_3LmRaBnH2gWyObedt1ka2N",
	"json-payload-array": "_2pJy8AfhJ-BPvRfYpGw1by",
	"jsonPayloadArray": "_2pJy8AfhJ-BPvRfYpGw1by",
	"json-payload-object": "_1BA1SbjZvdRmWH04EgYW_E",
	"jsonPayloadObject": "_1BA1SbjZvdRmWH04EgYW_E",
	"string": "_-6VWL5jq42gdU8IAaeyaZ",
	"number": "_2QUr-5bBL92DL7D3o5yJVQ",
	"boolean": "_2ioumvoqJC3jtc_Oi-GL0J",
	"key": "_3Ao6vWP9iMqek8ddof2GbM",
	"value": "Tw7PKhn38U-pBfw9wKyju",
	"invalid": "_1W_loGH-7LSLaHLQYM7Sj1"
};
module.exports = exports;
